import { render, staticRenderFns } from "./SelfRegisterMerchant.vue?vue&type=template&id=30101ae0&scoped=true&"
import script from "./SelfRegisterMerchant.vue?vue&type=script&lang=js&"
export * from "./SelfRegisterMerchant.vue?vue&type=script&lang=js&"
import style0 from "./SelfRegisterMerchant.vue?vue&type=style&index=0&id=30101ae0&scoped=true&lang=css&"
import style1 from "./SelfRegisterMerchant.vue?vue&type=style&index=1&id=30101ae0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30101ae0",
  null
  
)

export default component.exports